export enum UserRole {
  SuperAdmin = 'superadmin',
  CompanyAdmin = 'company_admin',
  CompanyUser = 'company_user',
  Pilot = 'pilot',
  Machine = 'kiosk',
}
